var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillLevelDonutThreeQuarters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skill_level_donut_three_quarter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.06298 11.2178C9.87204 11.2178 11.3386 9.75132 11.3386 7.94226C11.3386 6.1332 9.87204 4.66667 8.06298 4.66667C6.25393 4.66667 4.78739 6.1332 4.78739 7.94226C4.78739 9.75132 6.25393 11.2178 8.06298 11.2178Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 4",
    d: "M8 0C9.58225 1.88681e-08 11.129 0.469192 12.4446 1.34824C13.7602 2.22729 14.7855 3.47672 15.391 4.93853C15.9965 6.40034 16.155 8.00887 15.8463 9.56072C15.5376 11.1126 14.7757 12.538 13.6569 13.6569C12.538 14.7757 11.1126 15.5376 9.56072 15.8463C8.00887 16.155 6.40034 15.9965 4.93853 15.391C3.47672 14.7855 2.22729 13.7602 1.34824 12.4446C0.469192 11.129 -3.77363e-08 9.58225 0 8L4.664 8C4.664 8.6598 4.85965 9.30478 5.22622 9.85338C5.59278 10.402 6.11379 10.8296 6.72337 11.0821C7.33294 11.3346 8.0037 11.4006 8.65082 11.2719C9.29794 11.1432 9.89236 10.8255 10.3589 10.3589C10.8255 9.89236 11.1432 9.29794 11.2719 8.65082C11.4006 8.0037 11.3346 7.33294 11.0821 6.72337C10.8296 6.11379 10.402 5.59278 9.85338 5.22622C9.30478 4.85965 8.6598 4.664 8 4.664L8 0Z",
    fill: "#164A3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillLevelDonutThreeQuarters);
export default __webpack_public_path__ + "static/media/skill_level_donut_three_quarters.2653557450d095200ce252d1152a2d2a.svg";
export { ForwardRef as ReactComponent };